import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import FormInputField from "../../../Component/FormInputField";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  pdf_size_5MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "../../../Action/snackbarAction";
import { useDispatch } from "react-redux";
import {
  addStoryType,
  getStoryTypeList,
  setParentCourse,
  updateShotVideo,
  uploadFileShort,
} from "../../../Action/courseAction";
import { useSelector } from "react-redux";
import AdminTable from "../../../Component/adminTable";
import Dropdown from "../../../Component/dropdown";
import { updateStory } from "../../../Action/adminPanelAction";
const CategoriesOptions = [
  {
    _id: 1,
    name: "RESULTS",
  },
  {
    _id: 2,
    name: "EXAM NOTIFICATION",
  },
  {
    _id: 3,
    name: "CONCEPT VIDEO",
  },
  {
    _id: 4,
    name: "YOUTUBE VIDEO",
  },
  {
    _id: 5,
    name: "SUCCESS STORIES",
  },
  {
    _id: 6,
    name: "BIGGEST OFFER",
  },
  {
    _id: 7,
    name: "LAUNCH EVENT",
  },
  {
    _id: 8,
    name: "DAY CHALLENGE",
  },
];
function EditDeleteStoryType() {
  const dispatch = useDispatch();
  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));
  const [list, setList] = useState([]);
  const [storyName, setStoryName] = useState("");
  const [iconImage, setIconImage] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [storyCategories, setStoryCategories] = useState("");
  const [storyOrder, setStoryOrder] = useState("");
  const [editData, setEditData] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    dispatch(
      getStoryTypeList((res) => {
        setList(res);
      })
    );
  };

  const handleEdit = (value) => {
    setEditData(value);
    setStoryName(value?.name);
    setIconImage(value?.icon);
    const findType = CategoriesOptions.find((item) => item._id === value.type);
    setStoryCategories(findType);
    setStoryOrder(value?.order);
    dispatch(setParentCourse("isEditMode", true));
  };

  const handleIconImageChange = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_5MB) {
      dispatch(showErrorSnackbar("File size should be less than 5 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setIconImage(reader.result);
      };
      reader.readAsDataURL(file);

      dispatch(
        uploadFileShort(file, async (resp) => {
          setIconUrl(resp?.fileUrl);
        })
      );
    }
  };

  const handleChangeOrder = (value) => {
    if (!/^[0-9]*$/.test(value)) return;
    setStoryOrder(value);
  };
  const validations = () => {
    return (
      storyName === "" ||
      (iconUrl && iconImage === "") ||
      storyOrder === "" ||
      storyCategories === ""
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const reqBody = {
      name: storyName,
      icon: iconUrl || iconImage,
      type: storyCategories?._id,
      order: storyOrder,
    };
    dispatch(
      updateStory(reqBody, editData?._id, async () => {
        dispatch(showSuccessSnackbar("Data Updated Successfully"));
        fetchData();
        dispatch(setParentCourse("isEditMode", false));
      })
    );
    // dispatch(
    //   addStoryType(reqBody, (res) => {
    //     dispatch(showSuccessSnackbar("Data Updated Successfully"));
    //     fetchData();
    //     dispatch(setParentCourse("isEditMode", false));
    //   })
    // );
  };

  const renderEditMode = () => {
    return (
      <div className="row formDiv m-0">
        <div className="col-12 formDiv d-flex ">
          <form className="formWidth col-12" onSubmit={handleSubmit}>
            <div className=" col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Categories Type"} isRequired />
              <Dropdown
                setInputText={(value) => setStoryCategories(value)}
                value={storyCategories}
                options={CategoriesOptions}
                labelName="Select Categories Type"
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-6">
              <LabelField labelName={"Story Type"} />
              <FormInputField
                placeholder={"Enter Story Type"}
                setInputText={(value) => setStoryName(value)}
                value={storyName}
                isMandatary={true}
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-6">
              <LabelField labelName={"Order"} isRequired />
              <FormInputField
                placeholder={"Order"}
                setInputText={handleChangeOrder}
                value={storyOrder}
                maxLength={3}
              />
            </div>
            <div className="d-flex mb-2 align-items-center col-6">
              <div className="mb-2">
                <ImagePickerAndViewer
                  labelName={"Icon Image"}
                  value={iconImage || iconUrl}
                  handleChange={(e) => handleIconImageChange(e)}
                  htmlFor={`photo-upload`}
                  Isrequired={true}
                />
              </div>
            </div>
            <div className="col-auto d-flex justify-content-center">
              <div className="col-auto d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className={`btn mb-3 submitbtn ${
                    validations() ? "btn-secondary" : "btn-primary"
                  }`}
                  disabled={validations()}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const renderListMode = () => {
    return (
      <>
        <div className="col-12 ">
          <AdminTable
            tableData={list?.length > 0 ? list : []}
            pagename={"storyTypePage"}
            tableHead={["S.N", "Story Type Name", "Story Type Icon", "Action"]}
            handleEdit={(value) => handleEdit(value)}
            edit={true}
          />
        </div>
      </>
    );
  };

  const handleCancelEditMode = () => {
    dispatch(setParentCourse("isEditMode", false));
  };

  return (
    <div>
      <PageTitle
        name={"EDIT STORY TYPE"}
        isEditMode={isEditMode}
        onClick={handleCancelEditMode}
      />
      <div className="row formDiv m-0">
        <div className="col-12 formWidth pt-3">
          {!isEditMode ? renderListMode() : renderEditMode()}
        </div>
      </div>
    </div>
  );
}

export default EditDeleteStoryType;
